<template>
  <div class="border-top py-2">
    <div class="d-flex">
      <div class="break-white-space">
        {{ data.content.Text.Text }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      required: true,
      type: Object,
    },
    dataLength: {
      required: true,
      type: Number,
    },
    channelList: {
      required: true,
      type: Array,
    },
  },
  computed: {
    channelType: function () {
      return this.channelList.find((el) => {
        return el.id == this.data.channelTypeId;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.border-radius-5 {
  border-radius: 5px;
}
.break-white-space {
  white-space: break-spaces;
}
</style>
